const DataTypeMap = {
    'invoice': 0,
    'workOrder': 1,
    'quote': 2
}

const DataTypeUrlCodeMap = {
    'invoice': 'inv',
    'workOrder': 'wo',
    'quote': 'quote'
}

const dataTypeFromCode = (code) => {
    return Object.keys(DataTypeMap).find((key) => DataTypeMap[key] === code);
}

const dataTypeToCode = (dataType) => {
    return DataTypeUrlCodeMap[dataType];
}

export { DataTypeMap, DataTypeUrlCodeMap, dataTypeFromCode, dataTypeToCode };
